module.exports = __webpack_public_path__ + "img/yuyin.433e2243.png";